import script from "./AlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertBox.vue?vue&type=script&setup=true&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=c071007e&lang=css"

const __exports__ = script;

export default __exports__